import { render, staticRenderFns } from "./HistoricoRealinhar.vue?vue&type=template&id=4193f772"
import script from "./HistoricoRealinhar.vue?vue&type=script&lang=js"
export * from "./HistoricoRealinhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports